<template>
  <div class="assegna" v-if="calciatoreInAsta">
    <v-card dark class="navy asta-assegna-card" elevation="0">
      <v-card-title class="white--text pt-3 pb-1">
        <span class="asta-assegna-title body-2 font-weight-medium">
          <span
            v-if="ruoloCalciatoreInAsta"
            class="Ruolo "
            :class="'Ruolo_' + ruoloCalciatoreInAsta"
          >
            {{ ruolo(ruoloCalciatoreInAsta) }}
          </span>
          <b class="asta-assegna-calciatore-name">{{ nomeCalciatoreInAsta }}</b>
          <span v-if="nomeClubCalciatoreInAsta" class="asta-assegna-club">
            ({{ nomeClubCalciatoreInAsta }})
          </span>
          <span> - Assegna a...</span>
        </span>
      </v-card-title>

      <v-card-text class="pa-3 pb-2">
        <v-row dense>
          <!-- seleziona squadra -->
          <v-col cols="8">
            <v-select
              v-model="selected"
              :items="squadreDropdown"
              item-text="name"
              item-value="id"
              item-disabled="disabled"
              :menu-props="{ contentClass: 'asta-assegna-squadre-menu' }"
              outlined
              dense
              hide-details
              label="Seleziona squadra"
              no-data-text="Nessuna squadra disponibile"
              dark
            >
              <template #selection="{ item }">
                <div class="squadra-dropdown-selection">
                  <v-avatar size="24" class="mr-2">
                    <img :src="item.pic" />
                  </v-avatar>
                  <span class="squadra-dropdown-name">{{ item.name }}</span>
                </div>
              </template>

              <template #item="{ item }">
                <v-list-item-avatar>
                  <img :src="item.pic" />
                </v-list-item-avatar>

                <v-list-item-content class="squadra-dropdown-item-content">
                  <v-list-item-title
                    v-text="item.name"
                    class="squadra_name squadra-option-name"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-if="item.disabledReason"
                    class="squadra-disabled-reason"
                  >
                    {{ item.disabledReason }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-select>
          </v-col>

          <!-- crediti -->
          <v-col cols="4">
            <v-text-field
              :value="offerta"
              outlined
              dense
              readonly
              hide-details
              label="Costo"
              append-icon="edit"
              class="crediti-input"
              dark
              @click="showNumpad()"
              @click:append="showNumpad()"
              @keydown.prevent
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="px-2 py-1">
        <v-btn
          v-if="canAnnullaSelezione"
          rounded
          text
          small
          :loading="processingAnnulla"
          :disabled="processing"
          @click="annullaSelezione()"
          >Annulla</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn rounded outlined dark small @click="scarta()">Scarta</v-btn>
        <v-btn
          depressed
          rounded
          small
          color="accent"
          class="px-3 navy--text"
          :loading="loading"
          @click="assegna()"
          :disabled="
            selected == null || offerta == null || squadraDisabled(selected)
          "
          >Assegna</v-btn
        >
        <!-- asta_choosers.indexOf(selected) == -1 ||
            offerta > squadra(selected).max_offerta -->
      </v-card-actions>

      <!-- error -->
      <div class="px-2 pb-2">
        <v-alert
          dense
          text
          color="error"
          class="mb-0"
          v-model="error"
        >
          Offerta {{ errorValue }} non valida. Min: {{ minOfferta }} - Max:
          {{ maxOfferta }}
        </v-alert>
      </div>
    </v-card>
  </div>
</template>

<script>
import db from "../../js/db";
import mixins from "../../js/mixins";
import astaAssegnaActionsMixin from "../../js/mixins/astaAssegnaActionsMixin";
import toast from "../../js/toast";

export default {
  mixins: [mixins, toast, astaAssegnaActionsMixin],
  mounted() {
    console.log("--> AstaAssegna ready.");
    db.on("numpadSubmitted", this.setOffertaDaNumpad);
  },
  destroyed() {
    console.log("<-- AstaAssegna destroyed.");
    db.off("numpadSubmitted", this.setOffertaDaNumpad);
  },
};
</script>
<style lang="scss" scoped>
@import "../../main.scss";

.asta-assegna-title {
  align-items: center;
  display: flex;
  gap: 4px;
  min-width: 0;
  width: 100%;
}

.asta-assegna-calciatore-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.asta-assegna-club {
  opacity: 0.8;
  white-space: nowrap;
}

.asta-assegna-card::v-deep .v-label {
  font-size: 13px;
}
.asta-assegna-card::v-deep .v-card__actions .v-btn {
  letter-spacing: 0;
}
.squadra_list_item.selected {
  background: var(--v-text-base);
  .squadra_name {
    color: white !important;
  }
}
.squadra_list_item.v-list-item--disabled {
  opacity: 0.3;
}
.crediti-input {
  width: 100%;
}
.crediti-input::v-deep input {
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
}
.crediti-input::v-deep .v-input__append-inner .v-icon {
  font-size: 16px;
}
.squadra-dropdown-selection {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
}
.squadra-dropdown-selection .v-avatar {
  flex: 0 0 auto;
}
.squadra-dropdown-item-content {
  min-width: 0;
}
.squadra-dropdown-name,
.squadra_name,
.squadra-option-name {
  display: block;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.squadra-disabled-reason {
  color: var(--v-error-base) !important;
  display: block;
  font-size: 11px;
  line-height: 1.2;
  margin-top: 2px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.asta-assegna-squadre-menu .squadra-disabled-reason {
  color: var(--v-error-base) !important;
}
</style>
